/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, TextField, Autocomplete } from '@mui/material';
import { FieldArray } from 'formik';

const TravelerSelectionSection = ({ formik, selectedTravellers, searchResults, searchLoading, searchError, handleTravellerSelection, searchTravellers }) => (
    <>
        {/* Number of Travelers */}
        <Grid item xs={12} md={6}>
            <TextField
                name="travellersCount"
                label="Number of Travellers"
                type="number"
                fullWidth
                value={formik.values.travellersCount}
                onChange={(e) => {
                    const count = Math.max(1, Math.min(20, parseInt(e.target.value, 10) || 1));
                    formik.setFieldValue('travellersCount', count);
                    const currentUserIds = [...formik.values.userIds];
                    while (currentUserIds.length < count) {
                        currentUserIds.push('');
                    }
                    formik.setFieldValue('userIds', currentUserIds.slice(0, count));
                }}
                error={formik.touched.travellersCount && Boolean(formik.errors.travellersCount)}
                helperText={formik.touched.travellersCount && formik.errors.travellersCount}
                InputProps={{
                    inputProps: { min: 1, max: 20 }
                }}
            />
        </Grid>

        {/* Traveler Selection */}
        <Grid item xs={12}>
            <FieldArray name="userIds">
                {({ replace }) => (
                    <Grid container spacing={2}>
                        {Array.from({ length: formik.values.travellersCount || 1 }).map((_, index) => (
                            <Grid item xs={12} key={index}>
                                <Autocomplete
                                    options={[...selectedTravellers, ...searchResults]}
                                    getOptionLabel={(option) =>
                                        option?.employeeNumber
                                            ? `${option.employeeNumber} (${option.email})`
                                            : option?.email || ''
                                    }
                                    value={
                                        formik.values.userIds[index]
                                            ? selectedTravellers.find(
                                                  (user) => user.id === formik.values.userIds[index]
                                              ) || null
                                            : null
                                    }
                                    onChange={(_, selectedUser) => {
                                        handleTravellerSelection(index, selectedUser, replace);
                                    }}
                                    onInputChange={(_, newInputValue) => {
                                        if (newInputValue?.length >= 2) {
                                            searchTravellers(newInputValue);
                                        }
                                    }}
                                    loading={searchLoading}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={`Traveller ${index + 1}`}
                                            error={
                                                (formik.touched.userIds?.[index] &&
                                                    Boolean(formik.errors.userIds?.[index])) ||
                                                Boolean(searchError)
                                            }
                                            helperText={
                                                (formik.touched.userIds?.[index] &&
                                                    formik.errors.userIds?.[index]) ||
                                                searchError
                                            }
                                        />
                                    )}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </FieldArray>
        </Grid>
    </>
);

TravelerSelectionSection.propTypes = {
    formik: PropTypes.object.isRequired,
    selectedTravellers: PropTypes.array.isRequired,
    searchResults: PropTypes.array.isRequired,
    searchLoading: PropTypes.bool.isRequired,
    searchError: PropTypes.string,
    handleTravellerSelection: PropTypes.func.isRequired,
    searchTravellers: PropTypes.func.isRequired
};

export default TravelerSelectionSection; 